// File: cgp-breadcrumbs.module.ts
// Author: Joseph M Diaz
// Date: 5/1/2017
// Desc: CGP Breadcrumbs module.
// Other Contributors:

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';

import { CgpBreadcrumbsService } from './cgp-breadcrumbs.service';
import { CgpBreadcrumbsComponent } from './cgp-breadcrumbs.component';
import { CgpNotificationMenuModule } from '../cgp-notification-menu/cgp-notification-menu.module';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatMenuModule,
        CgpNotificationMenuModule
    ],
    exports: [
        CgpBreadcrumbsComponent
    ],
    declarations: [
        CgpBreadcrumbsComponent,
    ],
    providers: [
        CgpBreadcrumbsService
    ]
})
export class CgpBreadcrumbsModule { }